import type { Thunk, Action } from 'easy-peasy';
import { thunk, action } from 'easy-peasy';
import type { StoreModel } from '..';
import type { Injections } from '../services/injections';
import type { FetchCarrierSelectionSummaryParams, CarrierSelectionSummary } from '../services/DatalakeService/types';
import hash from 'object-hash';
import parseStatusCode from '../errors/parseStatusCode';
import type { ApplicationErrorOptions } from '../../types';

export interface DatalakeModel {
  lastAction?: number;
  datalakeFailure: Action<DatalakeModel, ApplicationErrorOptions>;
  datalakeActionStart: Action<DatalakeModel, void>;
  fetchCarrierSelectionSummaries: Thunk<
    DatalakeModel,
    FetchCarrierSelectionSummaryParams,
    Injections,
    StoreModel,
    Promise<CarrierSelectionSummary[]>
  >;
  setCarrierSelectionSummaries: Action<
    DatalakeModel,
    { params: FetchCarrierSelectionSummaryParams; results: CarrierSelectionSummary[] }
  >;
  carrierSelectionSummaries: Record<string, CarrierSelectionSummary[]>;
}

export const datalakeModel: DatalakeModel = {
  datalakeActionStart: action((state, payload) => {
    state.lastAction = Date.now();
  }),
  datalakeFailure: action((state, payload) => {
    console.log(payload);
  }),
  carrierSelectionSummaries: {},
  setCarrierSelectionSummaries: action((state, payload) => {
    state.carrierSelectionSummaries[hash(payload.params)] = payload.results;
  }),
  fetchCarrierSelectionSummaries: thunk(async (actions, payload, { injections }) => {
    try {
      const { datalakeService } = injections;
      actions.datalakeActionStart();
      const res = await datalakeService.fetchCarrierSelectionSummaries(payload);
      actions.setCarrierSelectionSummaries({ results: res, params: payload });
      return res;
    } catch (error) {
      actions.datalakeFailure({
        error,
        httpCode: parseStatusCode(error),
        message: 'An error occured, unable to fetch carrier selection summaries.',
        asNotification: false,
      });
      return error;
    }
  }),
};
